import React, { useEffect } from "react";
import { Paper } from "@mui/material";
import "components/pages/transmissions/modal/detail/notes/report_notes/ReportNotes.css";
import useReportNotes from "components/pages/transmissions/modal/detail/notes/report_notes/useReportNotes";

import PreviousAlert from "components/pages/transmissions/modal/detail/previous_alert/PreviousAlert";
import AccountDocumentLink from "components/common/accountDocument/AccountDocumentLink";
import { ACCOUNT_DOCUMENT_TYPES } from "static/account_document";
import ReportNoteForm from "components/pages/transmissions/modal/detail/notes/report_notes/form/ReportNoteForm";
import Loading from "components/common/loading/Loading";
import ReportNoteSuggestionModal from "components/pages/transmissions/modal/detail/notes/suggestion_modal/ReportNoteSuggestionModal";
import MissingPatientDetailModal from "../../battery_information/MissingPatientDetailModal";
import { toggleMissingPatientDetailModal } from "app/store/transmission/slice/transmissionSlice";

const ReportNotes = ({ data }) => {
  const {
    reportId,
    isLoading,
    evokeReportNotes,
    reportAccountDetail,
    isUpdatingReportNotes,
    originalEvokeReportNotes,

    handleReportNote,
    fetchReportTemplates,
    handleReportNoteAlertUpdate,

    // noteSuggestion,
    showSuggestionModal,
    handleReportNoteSaveFlow,
    showMissingPatientDetailModal,
    dispatch,
  } = useReportNotes(data);

  useEffect(() => {
    if (data && reportId && reportAccountDetail) {
      fetchReportTemplates();
    }
  }, [
    data,
    reportId,
    reportAccountDetail,
    // noteSuggestion
  ]);

  return (
    <Paper variant="outlined" style={{ padding: "16px" }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className="report-note-header">
          <div style={{ fontWeight: 600 }}>Report Notes</div>
          <div className="report-note-header__actions">
            <AccountDocumentLink
              accountName={data?.account}
              documentType={ACCOUNT_DOCUMENT_TYPES.ALERT_PROTOCOL}
              label="Alert Protocol"
              hasTrailingDivider
            />
            <PreviousAlert />
          </div>
        </div>

        {isLoading || isUpdatingReportNotes ? (
          <Loading height="250px" />
        ) : (
          evokeReportNotes?.length > 0 && (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <ReportNoteForm
                rowData={data && data}
                reportNotes={evokeReportNotes}
                reportNoteList={originalEvokeReportNotes}
                handleReportNote={handleReportNote}
                handleReportNoteSaveFlow={handleReportNoteSaveFlow}
              />
            </div>
          )
        )}
      </div>

      {showSuggestionModal && (
        <ReportNoteSuggestionModal
          openModal={showSuggestionModal}
          notes={evokeReportNotes}
          handleReportNote={handleReportNoteAlertUpdate}
        />
      )}

      {showMissingPatientDetailModal && (
        <MissingPatientDetailModal
          showModal={showMissingPatientDetailModal}
          onClose={() => dispatch(toggleMissingPatientDetailModal(false))}
          notes={evokeReportNotes}
          handleReportNote={handleReportNoteAlertUpdate}
        />
      )}
    </Paper>
  );
};

export default ReportNotes;
